import React, { FC, memo } from 'react';
import classNames from 'classnames';

import IconChevronDown from '@zvuk-b2b/react-uikit/ui/icons/ChevronDown';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import type { AddressSelectTriggerProps } from './types';

import styles from '../index.module.scss';

const AddressSelectTrigger: FC<AddressSelectTriggerProps> = ({
  dropdownId,
  isOpen,
  selectedCount,
  totalCount,
  onClick,
}) => (
  <button
    id={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER}
    type="button"
    data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER}
    className={classNames(styles.trigger, {
      [styles.triggerOpen]: isOpen,
    })}
    aria-expanded={isOpen}
    aria-controls={dropdownId}
    onClick={onClick}>
    <span
      className={styles.triggerText}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER_TEXT}>
      <span
        className={styles.triggerTitle}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER_TITLE}>
        {TEXTS.AUDIO_REPORT_ADDRESSES_SELECTED_TITLE}
      </span>
      <span
        className={styles.triggerCount}
        data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER_COUNT}>
        {TEXTS.AUDIO_REPORT_ADDRESSES_SELECTED_COUNT_SHORT(selectedCount, totalCount)}
      </span>
    </span>
    <span
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER_ICON}
      className={classNames(styles.triggerIcon, {
        [styles.triggerIconOpen]: isOpen,
      })}>
      <IconChevronDown />
    </span>
  </button>
);

export default memo(AddressSelectTrigger);
